export function departmentTone(dept) {
  if (!dept || dept.department_id === "unassigned") {
    return "gold";
  }

  const name = String(dept.department_name || "").toLowerCase();
  if (name.includes("underwrit")) {
    return "purple";
  }
  if (name.includes("operation")) {
    return "blue";
  }

  const id = Math.abs(Number(dept.department_id) || 0);
  return ["blue", "purple", "teal", "green"][id % 4];
}

const METADATA_TONES = ["purple", "blue", "rose", "teal", "amber"];

const AVATAR_TONES = [
  "blue",
  "purple",
  "orange",
  "teal",
  "rose",
  "indigo",
  "amber",
  "green",
];

export function metadataPillTone(type) {
  const raw = String(type || "UNKNOWN");
  let hash = 0;
  for (let i = 0; i < raw.length; i += 1) {
    hash = (hash + raw.charCodeAt(i) * (i + 1)) % METADATA_TONES.length;
  }
  return METADATA_TONES[hash];
}

export function avatarTone(name) {
  const raw = String(name || "").trim().toLowerCase();
  if (!raw) {
    return "blue";
  }
  let hash = 0;
  for (let i = 0; i < raw.length; i += 1) {
    hash = (hash + raw.charCodeAt(i) * (i + 1)) % AVATAR_TONES.length;
  }
  return AVATAR_TONES[hash];
}

export function isUnassignedDepartmentName(name) {
  const lowered = String(name || "")
    .trim()
    .toLowerCase();
  return !lowered || lowered === "unassigned" || lowered === "unassigned work";
}

export function namedDepartments(departments = []) {
  return departments.filter((dept) => {
    if (!dept || dept.department_id === "unassigned") {
      return false;
    }
    return !isUnassignedDepartmentName(dept.department_name);
  });
}

export function listingDepartmentLabel(row) {
  if (!row || row.department_id === "unassigned") {
    return "";
  }
  if (isUnassignedDepartmentName(row.department_name)) {
    return "";
  }
  return String(row.department_name).trim();
}

export function formatDashCount(value) {
  const n = Number(value) || 0;
  return n > 0 ? n.toLocaleString() : "—";
}

export function departmentProgress(dept) {
  const pct = Math.min(100, Math.max(0, Number(dept?.assigned_pct) || 0));
  const members = Number(dept?.member_count) || 0;
  const assignedPeople =
    dept?.active_member_count != null
      ? Math.min(members, Number(dept.active_member_count) || 0)
      : Math.round((pct / 100) * members);
  return {
    pct,
    assignedPeople,
    unassignedPeople: Math.max(0, members - assignedPeople),
  };
}

export function inboxPageSubtitle(layout, tab = "pending") {
  if (tab === "overview") {
    if (layout === "org") {
      return "Pending and verified workload across the organization.";
    }
    if (layout === "senior") {
      return "Pending and verified workload across your departments.";
    }
    if (layout === "manager") {
      return "Pending and verified workload for you and your team.";
    }
  }

  if (tab === "groups") {
    return layout === "senior"
      ? "Workload across the departments you oversee."
      : "Overview of workload across all departments.";
  }

  if (tab === "verified") {
    if (layout === "org") {
      return "Organization-wide verified metadata records";
    }
    if (layout === "senior") {
      return "Verified records across your departments";
    }
    if (layout === "manager") {
      return "Verified records for you and your team";
    }
    return "Your verified records";
  }

  if (layout === "org") {
    return "Organization-wide metadata queue";
  }
  if (layout === "senior") {
    return "Metadata queues across your departments.";
  }
  if (layout === "manager") {
    return "Your team's metadata queue.";
  }
  return "Your assigned metadata queue";
}

export function inboxScopeLine(layout, summary = {}) {
  const named = namedDepartments(summary.departments);
  const names = named
    .map((dept) => dept.department_name)
    .filter(Boolean);

  if (layout === "org") {
    return "All Departments · All Users";
  }

  if (layout === "senior") {
    const members = Number(summary.member_count) || 0;
    const memberLabel = `${members} ${members === 1 ? "member" : "members"}`;
    return names.length ? `${names.join(" · ")} · ${memberLabel}` : memberLabel;
  }

  if (layout === "manager") {
    return `${names[0] || "Your Team"} · Your Team`;
  }

  return "Assigned to you";
}

export function currentPeriodLabel(date = new Date()) {
  return date.toLocaleString("en-US", { month: "short", year: "numeric" });
}

export function quickFilterCountLabel(filter, summary = {}) {
  if (filter.id === "all") {
    return Number(summary.pending || 0).toLocaleString();
  }
  if (filter.assigned_state === "unassigned") {
    return Number(summary.unassigned || 0).toLocaleString();
  }
  if (filter.assigned_state === "assigned") {
    return Number(summary.assigned || 0).toLocaleString();
  }
  if (filter.older_than_24h) {
    return Number(summary.older_than_24h || 0).toLocaleString();
  }
  if (filter.assigned_state === "mine") {
    return Number(summary.my_pending || 0).toLocaleString();
  }
  return "";
}
